import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import GKClientDataGrid from "components/GKClientDataGrid";
import dayjs from "dayjs";
import { useState } from "react";
import { IoIosSend } from "react-icons/io";
import axiosInstance from "utils/axiosInstance";
import TemplateModal from "./TemplateModal";

const Template = () => {
  const [templateModal, setTemplateModal] = useState(false);
  const [templateData, setTemplateData] = useState({});
  const [setSendTemplateModal] = useState(false);
  const [setSelectedTemplate] = useState({});

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["GET_ALL_TEMPLATES"],
    queryFn: () => axiosInstance.get("/super_admin_whatsapp/template/"),
  });

  const columns = [
    {
      headerName: "Name",
      field: "templateName",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      headerName: "Document",
      field: "includeDocument",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
      // renderCell: (params) => (
      //   <StatusField
      //     statusString={params?.row?.includeDocument ? "true" : "false"}
      //   />
      // ),
    },
    {
      headerName: "Approved Status",
      field: "approvedStatus",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
      // renderCell: (params) => (
      //   <StatusField
      //     statusString={params?.row?.approvedStatus ? "true" : "false"}
      //   />
      // ),
    },
    {
      headerName: "Created At",
      field: "createdAt",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
      valueFormatter: (params) => dayjs(params?.value).format("DD MMM YYYY"),
      valueGetter: (row) => row?.row?.createdAt || "N/A",
    },
    {
      headerName: "Actions",
      disableColumnMenu: true,
      headerAlign: "right",
      align: "right",
      flex: 1,
      minWidth: 80,
      field: "action",
      type: "action",
      renderCell: (params) => (
        <Grid container gap={1} justifyContent={"flex-end"}>
          <Tooltip title="Send Message">
            <IconButton
              color="primary"
              onClick={(event) => {
                event.stopPropagation();
                setSelectedTemplate(params.row);
                setSendTemplateModal(true);
              }}
            >
              <IoIosSend size={20} />
            </IconButton>
          </Tooltip>
        </Grid>
      ),
    },
  ];

  return (
    <>
      <GKClientDataGrid
        loading={isFetching}
        columns={columns}
        rows={data?.data?.data || []}
        onRowClick={(row) => {
          setTemplateData(row.row);
          setTemplateModal(true);
        }}
        headerComponent={
          <Grid container item xs={12} gap={1} justifyContent="flex-end">
            <Button
              sx={{
                fontSize: "0.7rem",
                fontFamily: '"Arial", sans-serif',
                textTransform: "none",
              }}
              onClick={() => {
                setTemplateData({});
                setTemplateModal(true);
              }}
              variant="contained"
            >
              Create Template
            </Button>
          </Grid>
        }
      />
      {templateModal && (
        <TemplateModal
          open={templateModal}
          setOpen={setTemplateModal}
          refetch={refetch}
          templateData={templateData}
        />
      )}
      {/* {sendTemplateModal && (
        <SendMessageModal
          open={sendTemplateModal}
          setOpen={setSendTemplateModal}
          selectedTemplate={selectedTemplate}
        />
      )} */}
    </>
  );
};

export default Template;
